import React from 'react';
import HomeContactForm from '../components/HomeContactForm';

const ContactUs = () => {
    return (
        <section id="stayconnect" className="stay-connect-section bglight position-relative">
            <div className="container">
                <div className="contactus-wrapp">
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <div className="heading-title wow fadeInUp text-center text-md-left" data-wow-delay="300ms">
                                <h3 className="darkcolor bottom20">Stay Connected</h3>
                            </div>
                        </div>
                        <div className="col-md-12 col-sm-12">
                            <div className="getin_form wow fadeInUp" data-wow-delay="400ms">
                                <div className="wpcf7 no-js" id="wpcf7-f22-o1" lang="en-US" dir="ltr">
                                    <div className="screen-reader-response"><p role="status" aria-live="polite" aria-atomic="true"></p> <ul></ul></div>
                                    <HomeContactForm />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactUs;